import React, { FC } from 'react';

import { formatCurrencyValue } from '@eika/currency-input';

import { SoeknadstypeWeb, SoeknadWeb } from '../../generated-types';
import { useTranslation } from '../../translations';

interface Props {
    soeknad: SoeknadWeb;
}

const Soeknadsdetaljer: FC<Props> = ({ soeknad }) => {
    const { oppsummering } = useTranslation();

    const textSoeknadstype = (soeknadstype: SoeknadstypeWeb | null) => {
        switch (soeknadstype) {
            case SoeknadstypeWeb.FLYTTE_BOLIGLAAN:
                return oppsummering.infoFlytteBoliglaan;
            case SoeknadstypeWeb.REFINANSIERE_BOLIGLAAN:
                return oppsummering.infoNaavaerendeBoliglaan;
            default:
                return '';
        }
    };

    return (
        <div className="row align-items margin-bottom-extra-large">
            <div className="min-width-300">
                {(soeknad.annenBolig === null || !soeknad.annenBolig) && (
                    <div className="column space-between-items margin-bottom-small">
                        <span className="text-bold">{textSoeknadstype(soeknad?.soeknadtype)}</span>
                        <span className="text-bold">
                            {formatCurrencyValue(soeknad?.eksisterendeLaanebeloep || 0)} kr
                        </span>
                    </div>
                )}
                {soeknad?.soektBeloep && soeknad?.soektBeloep > 0 && (
                    <div className="column space-between-items">
                        <span className="text-bold">
                            {soeknad.soeknadtype === SoeknadstypeWeb.NYTT_BOLIGLAAN
                                ? oppsummering.infoNyttBoliglaan
                                : oppsummering.infoOensketOekning}
                        </span>
                        <span className="text-bold">{formatCurrencyValue(soeknad?.soektBeloep || 0)} kr</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Soeknadsdetaljer;
